import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";
import LabeledInput from "@/react/components/LabeledInput";

export const SmallInput = styled(LabeledInput)`
  max-width: 150px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-end;
`;

export const CardsContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 49%;
  border: 1px solid ${COLORS.secondary};
  border-radius: 8px;
  padding: 4px;
  margin-top: 16px;
`;

export const TopCardSectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const TokenBottomCardSectionWrapper = styled.div`
  overflow-wrap: break-word;
`;

export const ClaimsBottomCardSectionWrapper = styled.pre`
  background-color: ${COLORS.gray10};
`;
